import axios from 'axios';
import { removeCurrentUser } from '../actions/auth';

export default function removeAuthToken(dispatch) {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('funleagueToken');
    dispatch(removeCurrentUser());
}